define('models/ChatList',[
    'lib/lodash4',
    'lib/knockout',
    'services/chatService',
    'util/ObservableModel'
], function (_, ko, chatService, ObservableModel) {
    'use strict';

    /**
     * Rolls up all current external chats in to a single source
     */
    return ObservableModel.extend({ }, function () {
        var self = this;

        self.id = 'chats';
        self.interactionType = ko.observable('chats');

        self.chats = ko.computed(function () {
            return chatService.activeChats();
        });

        /**
         * The state is always connected unless we have an incoming chat that is in the alerting state
         * @type {String}
         */
        self.state = ko.computed(function () {
            var isAlerting = _.some(self.chats(), function(chat) {
                return chat.isAlerting();
            });

            return isAlerting ? 'alerting' : 'connected';
        });

        self.active = ko.computed(function () {
            return chatService.activeChats().length > 0;
        });
    });
});
